<template>
  <div>
    <navbar />
    <div class="md:flex md:mt-4 menuWrapper">
      <Sidebar />
      <v-btn>Refresh</v-btn>
      <div class="md:ml-10">
        <div class="flex justify-end">
          <div class="md:flex border border-gray-600 justify-end">
            <input
              class="w-full px-2"
              placeholder="Search"
              type="text"
              v-model="search"
            />
          </div>
        </div>

        <v-data-table
          :headers="headers"
          :items="datatableItems"
          :search="search"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <div class="my-1">
              <v-btn small @click="openRow(item)">
                <v-icon small>mdi-eye</v-icon> open
              </v-btn>
              <v-btn class="mt-1" small @click="assign(item)">Assign</v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <TicketDialog @closeDialog="closeDialog" :showDialog="showDialog" />

    <div>
      <AssignDialog
        :openAssignDialog="openAssignDialog"
        @GetAssigned="GetAssigned"
        @closeAssignDialog="closeAssignDialog"
      />
    </div>
  </div>
</template>

<script>
// import HeaderTemplate from "@/components/HeaderTemplate";
// import TinyNavbar from "../../TinyNavbar.vue";
import AssignDialog from "./components/AssignDialog.vue";
import Navbar from "@/common/Navbar.vue";
import Sidebar from "@/common/Sidebar.vue";
import axios from "axios";
import TicketDialog from "./components/TicketDialog.vue";

export default {
  data() {
    return {
      openAssignDialog: false,
      showDialog: false,
      datatableItems: [],
      search: "",

      headers: [
        {
          text: "Ticket",
          value: "ticket_id",
        },
        {
          text: "Date Submitted",
          value: "reg_date",
        },
        {
          text: "Principal Buyer",
          value: "buyer_name",
        },
        {
          text: "Classification",
          value: "classification",
        },
        {
          text: "Subject",
          value: "subject",
        },
        {
          text: "Customer Code",
          value: "customer_code",
        },
        {
          text: "Ticket Location",
          value: "location",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
    };
  },
  components: { Navbar, Sidebar, TicketDialog, AssignDialog },
  watch: {
    "$route.name": {
      handler(e) {
        if (e == "Dashboard") {
          this.getTickets();
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeAssignDialog() {
      this.openAssignDialog = false;
    },
   
    closeDialog() {
      this.showDialog = false;
    },
    assign() {
      this.openAssignDialog = true;
    },
    openRow() {
      this.showDialog = true;
    },
    getTickets() {
      axios.get("/tickets").then((res) => {
        this.datatableItems = res.data;
      });
    },
  },
};
</script>

<style scoped>
.MenuWrapper {
  background: rgb(35, 35, 35);
  background: linear-gradient(
    156deg,
    rgba(35, 35, 35, 1) 0%,
    rgba(8, 133, 42, 1) 58%,
    rgba(62, 160, 89, 1) 76%,
    rgba(101, 179, 122, 1) 92%
  );
}
.buttons {
  background: rgb(72, 72, 72);
  background: linear-gradient(
    156deg,
    rgba(72, 72, 72, 1) 37%,
    rgba(117, 117, 117, 1) 77%
  );
}
</style>